import React from 'react'
import { bem } from '@argos/utils'

import SliderHandle from './SliderHandle'

const cn = bem({ prefix: 'lc-', block: 'feedback-slider' })

export class SliderBar extends React.Component {
  render() {
    const { xPosition, showToolTip, value } = this.props
    return (
      <div style={{ width: `${xPosition}%` }} className={cn('container', 'progress')}>
        <SliderHandle dragStart={this.dragStart} showToolTip={showToolTip} value={value} />
      </div>
    )
  }
}
export default SliderBar
